import { Injectable } from '@angular/core';

import { WalkthroughRegisterContract } from '@core/walkthrough-contracts';
import type { WalkthroughStepId, WalkthroughStepOrigin } from '@core/walkthrough-types';

@Injectable({ providedIn: 'root' })
export class WalkthroughStubService implements WalkthroughRegisterContract {
  public register(stepId: WalkthroughStepId, origin: WalkthroughStepOrigin): void {
    // No implementation needed for the stub
  }

  public unregister(stepId: WalkthroughStepId): void {
    // No implementation needed for the stub
  }
}
